import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const setPayrollBusinessRules = payload =>
  call(websocketFetch, 'set_payroll_business_rules', {
    payroll_business_rules: payload,
  });
